import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { computed, unref } from 'vue'
import { getApi } from './api'

export interface PlaceType {
  id: number
  slug: string
  name: string
  is_custom: boolean
  parent: string | null
  geofence_count?: number
}

/**
 * The GPX standard place types followed by the account's custom ones, unpaginated. Any member of
 * the account may read it; only its admins may write.
 */
export default (accountId: Ref<number> | number) => {
  return useQuery({
    queryKey: ['account-place-types', () => unref(accountId)],
    queryFn: async (): Promise<PlaceType[]> => {
      const { api, baseURL } = getApi()
      const res = await api.get(
        `/api/v2/accounts/${unref(accountId)}/place-types`,
        { baseURL },
      )
      return res.data.data
    },
    enabled: computed(() => !!unref(accountId)),
    staleTime: 5 * 60 * 1000,
  })
}
